export const COST_DASHBOARD_CHART_COLORS = [
  "#89CFF0",
  "#E6E6FA",
  "#FFDAB9",
  "#C8A2C8",
  "#FADADD",
  "#87CEEB",
  "#CCCCFF",
  "#F7CAC9",
  "#ff988d",
  "#88c4f8",
  "#AFEEEE",
  "#DE5D83",
  "#DABDFF",
  "#E0FFFF",
  "#FDD9B5",
  "#B0E0E6",
  "#FF91A4",
  "#00CED1",
  "#bdd7c9",
  "#BDFCC9",
  "#DCD0FF",
  "#F4C2C2",
  "#FFD8B1",
  "#87CEFA",
];

export const BASE_URL = {
  COST: "/app/cost/cost/",
  SPEND_ANALYSIS: "/app/cost/cost/spend-analysis",
  SPEND_BREAKDOWN: "/app/cost/cost/spend-breakdown",
};

export const DATE_FORMAT = { YYYY_MM_DD: "YYYY-MM-DD" };

export const QUERY_PARAM = {
  KEY: {
    START_DATE: "startDate",
    END_DATE: "endDate",
    FILTERED_ACCOUNTS: "filteredAccounts",
    FILTERED_SERVICES: "filteredServices",
    FILTERED_REGIONS: "filteredRegions",
    SPEND_TREND_RANGE: "spendTrendRange",
    SPEND_TREND_TYPE: "spendTrendType",
    RESOURCE_GROUP_BY: "resourceGroupBy",
    TAGS: "tags",
    KEYS: "keys",
    SELECTED_COUNT_ON_APPLY: "selectedCountOnApply",
  },
  VALUE: {
    MONTHLY: "Monthly",
    WEEKLY: "Weekly",
    DAILY: "Daily",
    YEARLY: "Yearly",
    QUARTERLY: "Quarterly",
    SIX_MONTHS: "6M",
    BY_ACCOUNT: "by-account",
    BY_REGION: "by-region",
    BY_SERVICE: "by-service",
    BY_TAG: "by-tag",
  },
};

export const CARD_CASE = {
  POSITIVE: "Positive",
  NEGATIVE: "Negative",
};

export const CHART_TYPE = {
  PIE: "pie",
  COLUMN: "column",
  BAR: "bar",
  LINE: "line",
};

export const SPEND_ANALYSIS = "spend-analysis";

export const FILTERS = {
  ACCOUNT_FILTERS: "accountFilters",
  SERVICE_FILTERS: "serviceFilters",
  REGION_FILTERS: "regionFilters",
};

export const COLUMN_IDS = {
  TOTAL_COST: "totalCost",
  SERVICE: "serviceName",
  ACCOUNT: "accountName",
  REGION: "regionName",
  RESOURCE_ID: "resourceId",
  TAGS: "tags",
};

export const API_FILTER_KEYS = {
  ACCOUNT_NUMBERS: "AccountNumbers",
  AWS_SERVICES: "AWSServices",
  REGIONS: "Regions",
  ACCOUNT_NUMBER: "AccountNumber",
  SERVICE: "Service",
  REGION: "Region",
  TAGS: "Tags",
  TAG: "Tag",
};

export const NO_REGION = "no-region";

export const NOT_AVAILABLE = "N/A";

export const REGION = "region";
export const ACCOUNT = "account";
export const TAG_KEY = "TagKey";
export const TAG_VALUE = "TagValue";
